<template>
  <div class="card questions">
    <div class="card-header">
      <h3 class="card-title">{{ $t('page.title.master_class_details') }}: <span
          v-if="masterClass">{{ masterClass.title }}</span></h3>
      <div class="float-right">
        <router-link :to="{'name':'master-classes-list'}">
          <b-button size="sm" variant="outline-primary">{{ $t('btn.back') }}</b-button>
        </router-link>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-6">
          <b-card v-if="masterClass">

            <b-card-header><b>{{ $t('page.general_information') }}</b></b-card-header>
            <b-card-body>
              <label>Id</label>
              <p>{{ masterClass.id }}</p>

              <label>{{ $t('page.masterClass.name') }}</label>
              <p>
                <input v-model="formEdit.name" v-if="isEdit" class="form-control">
                <span v-else>{{ masterClass.name }}</span>
              </p>

              <label>{{ $t('page.description') }}</label>
              <p>
                <input v-model="formEdit.description" v-if="isEdit" class="form-control">
                <span v-else>{{ masterClass.description }}</span>
              </p>

              <label>{{ $t('page.masterClass.author') }}</label>
              <p>
                <multiselect v-if="isEdit"
                     multiple
                     v-model="selectedAuthors"
                     :options="authors"
                     track-by="key"
                     label="value"
                ></multiselect>
                <span v-for="(authorId, index) in masterClass.authors" :key="authorId" v-else>
                      {{ getAuthorById(authorId) }}<span v-if="index != masterClass.authors.length - 1">, </span>
                </span>
              </p>

              <label>{{ $t('page.status') }}</label>
              <p>
                <vue-select
                    v-if="isEdit"
                    v-model="formEdit.status"
                    :options="statuses" :reduce="status => status.value"
                    label="text"
                ></vue-select>
                <span v-else>{{ masterClass.status }}</span>
              </p>

            </b-card-body>
          </b-card>
        </div>
        <div class="col-6">
          <b-card v-if="masterClass">
            <b-card-header><b>{{ $t('page.masterClass.trailer') }}</b></b-card-header>
            <b-card-body>
              <label>{{ $t('page.masterClass.trailer') }}</label>
              <p>
                <input v-model="formEdit.trailer" v-if="isEdit" class="form-control">
                <span v-else>{{ masterClass.trailer }}</span>
              </p>
              <vimeo v-if="masterClass.trailer && !isEdit" :vimeo-id="masterClass.trailer" title="masterClass.name"></vimeo>
              <vimeo v-if="formEdit.trailer && isEdit" :vimeo-id="formEdit.trailer" title="masterClass.name"></vimeo>

              <label>{{ $t('page.masterClass.introTrailer') }}</label>
              <p>
                <input v-model="formEdit.introTrailer" v-if="isEdit" class="form-control">
                <span v-else>{{ masterClass.introTrailer }}</span>
              </p>

              <vimeo v-if="masterClass.introTrailer && !isEdit" :vimeo-id="masterClass.introTrailer" title="masterClass.name"></vimeo>
              <vimeo v-if="formEdit.introTrailer && isEdit" :vimeo-id="formEdit.introTrailer" title="masterClass.name"></vimeo>

            </b-card-body>
          </b-card>
        </div>

      </div>
      <div class="buttons float-right">
        <b-button v-if="!isEdit" type="button" @click="startEdit()" variant="success" class="mr-1">{{ $t('actions.edit') }}</b-button>
        <b-button v-if="isEdit" type="button" @click="changeData()" variant="success" class="mr-1">{{ $t('actions.save') }}</b-button>
        <b-button v-if="isEdit" type="button" @click="isEdit = false" variant="danger" class="mr-1">{{ $t('actions.cancel') }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>

import alertify from 'alertifyjs';
import axios from "axios";
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.min.css";
import {mapState} from "vuex";
import { VueSelect } from "vue-select";
import "vue-select/dist/vue-select.css";
import Vimeo from "@/components/vimeo/Vimeo.vue";

export default {
  props: ['apiKey'],
  components: {
    Multiselect,
    VueSelect,
    Vimeo
  },
  data() {
    return {
      masterClassId: null,
      formEdit: {},
      isEdit: false,
      selectedAuthors: [],
      statuses: [
        {value: 'active', text: 'Active'},
        {value: 'inactive', text: 'Inactive'},
        {value: 'bonus', text: 'Bonus'},
      ],
    };
  },
  mounted() {
    this.getMasterClass();
    this.getAuthors();
  },
  computed: {
    masterClass: function () {
      return this.$store.getters["masterClassStore/masterClass"];
    },
    ...mapState({
      authors: (state) => state.masterClassStore.authors,
    }),
  },
  beforeDestroy() {
    this.$store.commit('masterClassStore/setMasterClass', null);
  },
  created() {
    this.masterClassId = this.$route.params.id;
  },
  methods: {
    getAuthors() {
      this.$store.dispatch('masterClassStore/getAuthors');
    },
    getAuthorById(id) {
      let obj = this.authors.find(author => author.key === id);

      return obj ? obj.value : null;
    },
    startEdit() {
      this.formEdit = JSON.parse(JSON.stringify(this.masterClass));
      this.isEdit = true;
      this.selectedAuthors = this.authors.filter((el) => this.masterClass.authors.includes(el.key));
    },
    getMasterClass() {
      this.$store.dispatch('masterClassStore/getMasterClass', this.masterClassId);
    },
    changeData() {
      const url = '/master-class/' + this.masterClassId +'/edit';
      this.formEdit.authors = this.selectedAuthors.map((el) => el.key);

      axios.post(url, this.formEdit)
          .then(() => {
            alertify.success('Klasa została zmieniona');
            this.getMasterClass();
            this.isEdit = false;
          })
          .catch(error => {
            alertify.error(error.response.data.label);
          });
    },
  },
  watch: {
    $route() {
    }
  }
}
</script>

